import { useQuery } from "react-query";
import { getBilling } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";

export const useGetBilling = () => {
  return useQuery("GetBilling", getBilling, {
    refetchOnWindowFocus: false,
  });
};
